<h1 mat-dialog-title>{{ 'timesheet.summary.title' | translate }}</h1>

<mat-dialog-content>
    @if (data && data.summaries && data.summaries.length > 0) {
        <h4>{{ 'timesheet.summary.per_client' | translate }} :</h4>
        <spurado-chip-list direction="vertical">
            @for (summary of data.summaries; track summary) {
                <spurado-chip [selected]="false" color="primary">
                    <div chipText>
                        @if (summary.client) {
                            <span>{{ summary.client }}</span>
                        } @else {
                            <span>{{ 'timesheet.summary.no_client' | translate }}</span>
                        }
                        <span>&nbsp;&#8594;&nbsp;</span>
                        @if (displayHours) {
                            <span>{{ summary.weekSummary | decimalHours }}</span>
                        }
                        @if (displayDays) {
                            <span>{{ getDays(summary.weekSummary) | number: '1.0-2' }}</span>
                        }
                        @if (summary.pourcentageOfWeekTotal > 0) {
                            <span>&nbsp;(=&nbsp;{{ summary.pourcentageOfWeekTotal | number: '1.0-2' }}%)</span>
                        }
                    </div>
                </spurado-chip>
            }
        </spurado-chip-list>

        <h4>{{ 'timesheet.summary.total' | translate }} :</h4>
        <spurado-chip-list direction="vertical">
            <spurado-chip color="primary">
                <div chipText>
                    @if (displayHours) {
                        <span>{{ totalInHours | decimalHours }}</span>
                    }
                    @if (displayDays) {
                        <span>{{ totalInDays | number: '1.0-2' }}&nbsp;{{ 'timesheet.summary.total_days' | translate }}</span>
                    }
                </div>
            </spurado-chip>
        </spurado-chip-list>
    } @else {
        <span>{{ 'timesheet.summary.no_data' | translate }}</span>
    }
</mat-dialog-content>
